import React, { useEffect, useState } from 'react';
import './index.css';
import { BASIC_FOODS, ItemName } from '../item/item-types';
import { getFoodFromIngredients } from '../item/item-utils';
import CauldronIngredients from './cauldron-ingredients';
import CauldronCooking from './cauldron-cooking';
import IngredientsTable from './ingredients-table';
import Filter from '../menu/filter';
import { PageSubTitle } from '../menu/page-sub-title';

const Cauldron: React.FC = () => {
    const [ingredients, setIngredients] = useState<[ItemName, ItemName]>([ItemName.Empty, ItemName.Empty]);
    const [resultFood, setResultFood] = useState<ItemName>(ItemName.Empty);
    const [filteredItems, setFilteredItems] = useState<ItemName[]>(BASIC_FOODS);

    useEffect(() => {
        if (window.location.hash) {
            const element = document.getElementById(window.location.hash.substring(1));
            if (element) {
                element.scrollIntoView({ behavior: 'smooth' });
            }
        }
    }, []);

    useEffect(() => {
        if (ingredients[0] !== ItemName.Empty && ingredients[1] !== ItemName.Empty) {
            const result = getFoodFromIngredients(ingredients[0], ingredients[1]);
            if (result) {
                setResultFood(result);
            } else {
                console.log(`Something went wrong. No result for combining ${ingredients[0]} and ${ingredients[1]}`);
            }
        }
    }, [ingredients]);


    return (
        <div className='cauldron'>
            <PageSubTitle
                label='Cauldron'
                name='cauldron'
                image='/resources/cauldron/cauldron_icon.png'
                /*id='cauldron'*/
            />
            <div className='cauldron-content'>
                <CauldronCooking ingredients={ingredients} resultFood={resultFood} />
                <div className='cauldron-toolbar'>
                    <button
                        className='clear-cooking-button'
                        onClick={() => {
                            setIngredients([ItemName.Empty, ItemName.Empty]);
                            setResultFood(ItemName.Empty);
                        }}
                    >
                        <div>Clear</div>
                    </button>
                    <div className="cauldron-toolbar-filter">
                        <Filter
                            items={BASIC_FOODS}
                            setFilteredItems={setFilteredItems}
                        />
                    </div>
                </div>
                <CauldronIngredients itemsToDisplay={filteredItems} setIngredients={setIngredients} />
            </div>
            <IngredientsTable />
        </div >
    );
};

export default Cauldron;